import axios from "axios";

const API_URL = "https://react.moobeenquader.com/mail.php";

export const sendContactForm = async (data) => {
  try {
    const formData = new FormData();

    formData.append("name", data.name);
    formData.append("email", data.email);
    formData.append("phone", data.phone);
    formData.append("subject", data.subject);
    formData.append("message", data.message);

    const response = await axios.post(API_URL, formData);

    return response.data;
  } catch (error) {
    console.error(error);

    return {
      success: false,
      error: error.message,
    };
  }
};